import { render, staticRenderFns } from "./LoginCliente.vue?vue&type=template&id=be4abc3a&scoped=true&"
import script from "./LoginCliente.vue?vue&type=script&lang=js&"
export * from "./LoginCliente.vue?vue&type=script&lang=js&"
import style0 from "./LoginCliente.vue?vue&type=style&index=0&id=be4abc3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4abc3a",
  null
  
)

export default component.exports